import { render, staticRenderFns } from "./OperativeTableBodyRowKpiRating.vue?vue&type=template&id=2a8b612c&"
import script from "./OperativeTableBodyRowKpiRating.vue?vue&type=script&lang=js&"
export * from "./OperativeTableBodyRowKpiRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports